import { Typography } from 'antd';

interface Props {
	explanation: string;
	// Pending-move details are rendered by GroupActionBlock alongside the
	// Confirm/Undo buttons — keep the props on this component for
	// backward compatibility but don't render them here (avoids the
	// duplicate yellow box).
	pendingTargetArea?: string | null;
	pendingTargetLabel?: string | null;
}

export function CardDetailExplanation({ explanation }: Props) {
	if (!explanation) {
		return <Typography.Text type="secondary">No status detail available.</Typography.Text>;
	}
	return <Typography.Paragraph>{explanation}</Typography.Paragraph>;
}
